import { OpenFlag } from '@/api/resort/types';
import { I18nKey } from '@/i18n/types';

// OpenFlag → translation key. Lives in its own module (no react-i18next
// import) so server-side consumers — the LdJson schema builders rendered
// from RSC pages — can share the map without pulling the client i18n
// binding into a server graph. Client code keeps importing it via the
// re-export in `useOTSTranslation`.
export const openFlagMap: Record<OpenFlag, I18nKey['common']> = {
  [OpenFlag.Closed]: 'resort.skiReport.closed',
  [OpenFlag.TemporarilyClosed]: 'resort.skiReport.temporarilyClosed',
  [OpenFlag.PermanentlyClosed]: 'resort.skiReport.permanentlyClosed',
  [OpenFlag.NoReportAvailable]: 'resort.skiReport.noReportAvailable',
  [OpenFlag.WeekendsOnly]: 'resort.skiReport.weekendsOnly',
  [OpenFlag.Open]: 'resort.skiReport.open',
};
